import { renderSlot as _renderSlot, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: ['gfu-field__drop-area',
                  {
                      'gfu-field__drop-area--active': $data.isActive && $props.enabled,
                      'gfu-field__drop-area--preview': $props.preview,
                      'gfu-field__drop-area--disabled': !$props.enabled
                  }]
  }, _toHandlers($options.fieldListeners, true), { "data-qa": "drop-area" }), [
    _renderSlot(_ctx.$slots, "default")
  ], 16 /* FULL_PROPS */))
}